// store.js
import Vue from 'vue';
import Vuex from 'vuex';
import * as getters from './getters';
import * as actions from './actions';
import * as mutations from './mutations';
import { version, name } from '../../package.json';

Vue.use(Vuex);
const projectVersion = version.replace(/\./gi, '-');
const projectFolder = `/media/landing-collections/${name}-${projectVersion}/`;
function getBasePath(isExternal = false) {
  let basePath = '';
  if (!window.location.origin) {
    window.location.origin = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;
  }
  if (window.location.origin.indexOf('paris') > -1) {
    basePath = isExternal && window.___external___hosting ?
      window.___external___hosting : `${window.location.origin}${projectFolder}`;
  }

  return isExternal && (window.___external___hosting && window.___force___external === 'true') ? window.___external___hosting : basePath; // Debug flag
}
export function createStore(attributes = undefined) { // eslint-disable-line
  return new Vuex.Store({
    state: {
      init: false,
      loaded: false, // Helps tempo 3D rendering
      mode: 'test', // used to render links for products
      projectFolder,
      basePath: getBasePath(),
      staticAssetsPath: `${getBasePath(true)}statics/`,
      isIE: !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g),
      browser: null,
      config: {},
      theme: 'liberty',
      defaultCollection: 'liberty',
      wave: 1, // Will be overriden if a wave attributes is set in mdp.config
      isMobile: true,
      debug: false,
      name,
      version: projectVersion,
      attributes,
    },
    getters,
    actions,
    mutations,
  });
}
